const map = {
  overtimeCarDetail: () => import('@/views/humanResourceManagement/overtimeVehicleManagement/OvertimeCarDetail'), // 加班用车明细
  teamBuildingMonthlyAccounting: () => import('@/views/humanResourceManagement/overtimeVehicleManagement/TeamBuildingMonthlyAccounting') // 团建费用月度核算
}

export default map
